module.exports = __webpack_public_path__ + "img/Rugby-Sevens.e4e74f81.png";